"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CounterSubject = void 0;
const rxjs_1 = require("rxjs");
class CounterSubject extends rxjs_1.BehaviorSubject {
    constructor(counter = 0, allowNegative = false) {
        super(counter);
        this.allowNegative = allowNegative;
    }
    increase(count = 1) {
        this.next(this.value + count);
    }
    decrease(count = 1) {
        if (!this.allowNegative && this.value === 0) {
            return;
        }
        if (!this.allowNegative && this.value - count < 0) {
            this.next(0);
        }
        else {
            this.next(this.value - count);
        }
    }
}
exports.CounterSubject = CounterSubject;
